var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgMail = function SvgMail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 19,
    viewBox: "0 0 24 19",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.7 4.4H2.4c2.1 1 8.8 8.2 9.6 9zM16 11.9l6.8 6.4V5.5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 15.6 9.2 13l-6.8 6.4h19.3c-1.3-1.2-4.5-4.2-6.8-6.4-.1 0-2.9 2.6-2.9 2.6zM1.2 5.5v12.8l6.9-6.4"
  })));
};

export { SvgMail as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyBlbmFibGUtYmFja2dyb3VuZD0ibmV3IDAgMCAyNCAxOSIgeD0iMHB4IiB5PSIwcHgiIHdpZHRoPSIyNHB4IiBoZWlnaHQ9IjE5cHgiIHZpZXdCb3g9IjAgMCAyNCAxOSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48Zz48cGF0aCBkPSJtMjEuNyA0LjRoLTE5LjNjMi4xIDEgOC44IDguMiA5LjYgOXoiLz48cGF0aCBkPSJtMTYgMTEuOSA2LjggNi40di0xMi44Ii8+PHBhdGggZD0ibTEyIDE1LjYtMi44LTIuNi02LjggNi40aDE5LjNjLTEuMy0xLjItNC41LTQuMi02LjgtNi40LS4xIDAtMi45IDIuNi0yLjkgMi42eiIvPjxwYXRoIGQ9Im0xLjIgNS41djEyLjhsNi45LTYuNCIvPjwvZz48L3N2Zz4K";